const locale = {
  //Banking
  INDEX_NAME_BANKING: "Banking",
  View_Video: "View Video",
  Test_Title: "Evaluación",
  Question_One: "Sample Question1",
  Question_Two: "Sample Question2",
  Question_Three: "Sample Question3",
  Question_Four: "Sample Question4",
  Question_Five: "Sample Question5",
  Question_Six: "Sample Question6",
  Question_Seven: "Sample Question7",
  Question_Eight: "Sample Question8",
  Question_Nine: "Sample Question9",
  Question_Ten: "Sample Question10",
  //radio options
  Rad_One: "Radio Option1",
  Rad_Two: "Radio Option2",
  Rad_Three: "Radio Option3",
  Rad_Four: "Radio Option4",
  RadioBtn_Error: "Please select an option",
  Submit_BTN: "Submit",
  ReAttampt_BTN: "Re-Attempt",
  //error messages
  Error_Message: "Please select an option",

  //Certification
  INDEX_NAME: "Cetification",
  View_Video: "View Video",
  Test_Title: "Assessment",
  Question_One: "Sample Question1",
  Question_Two: "Sample Question2",
  Question_Three: "Sample Question3",
  Question_Four: "Sample Question4",
  Question_Five: "Sample Question5",
  Question_Six: "Sample Question6",
  Question_Seven: "Sample Question7",
  Question_Eight: "Sample Question8",
  Question_Nine: "Sample Question9",
  Question_Ten: "Sample Question10",
  //radio options
  Rad_One: "Radio Option1",
  Rad_Two: "Radio Option2",
  Rad_Three: "Radio Option3",
  Rad_Four: "Radio Option4",
  RadioBtn_Error: "Please select an option",
  Submit_BTN: "Submit",
  ReAttampt_BTN: "Re-Attempt",
  //error messages
  Error_Message: "Please select an option",

  //Orientation
  INDEX_NAME_ORIENTATION: "Orientation",
  View_Video: "View Video",
  Test_Title: "Assessment",
  Question_One: "Sample Question1",
  Question_Two: "Sample Question2",
  Question_Three: "Sample Question3",
  Question_Four: "Sample Question4",
  Question_Five: "Sample Question5",
  Question_Six: "Sample Question6",
  Question_Seven: "Sample Question7",
  Question_Eight: "Sample Question8",
  Question_Nine: "Sample Question9",
  Question_Ten: "Sample Question10",
  //radio options
  Rad_One: "Radio Option1",
  Rad_Two: "Radio Option2",
  Rad_Three: "Radio Option3",
  Rad_Four: "Radio Option4",
  RadioBtn_Error: "Please select an option",
  Submit_BTN: "Submit",
  ReAttampt_BTN: "Re-Attempt",
  //error messages
  Error_Message: "Please select an option",

  //Proof of residency
  INDEX_NAME: "Upload File",
  BROWSE_BTN: "Browse",
  Acceptable_Documents: "Acceptable Documents",
  Type: "Type",
  UPLOAD_HINT: "Only jpg, jpeg, png and pdf files are supported. ",

  SELECTED_DOCUMENTS_ERROR: "You must select at least one document",

  Drivers_licens:
    "Unexpired state-issued Drivers License, Learner's Permit, or Non-Driver's Identification Card",
  Official_School_Record:
    "Official School Record such as a transcript or report card (must show participant's name and address)",
  Immunization_Record:
    "Immunization record (must show participant's name and address and must be signed and dated by a school official)",
  Income_Tax_Form: "2014 Income Tax Form 1040 (must be signed and notarized) ",
  Executed_Lease:
    "Executed Lease or Rental Agreement dated within one year (must be signed and dated 2014 W-2)",
  notics:
    "(*We will not accept any documents from the Office of Youth Programs All documents verifying residence must show participants name and address) ",
  No_FILE_SELECTED: "No file selected ",

  Learners_Permit: "Learner's Permit",

  Non_Drivers_Identification_Card: "Non-Driver's Identification Card",

  Official_School_Record: "Official School Record",

  Immunization_record: "Immunization record",
  Income_Tax_Form: "Income Tax Form",
  Executed_Lease_Rental_Agreement: "Executed Lease or Rental Agreement",
  APPROVAL_STATUS: "Approval Pending",
  PROOF_OF_RESIDENCY_DESCRIPTION:
    "To ensure accurate record-keeping and participant identification, we require a copy of your child's identification document, such as an Unexpired state-issued Drivers License, Learner's Permit, Non-Driver's Identification Card, Official School Record, Immunization record, Income Tax Form, Executed Lease or Rental Agreement. This verification process is crucial for program administration and ensuring the safety and security of all participants.",
  //Proof of age
  Index_Name: "Upload File",
  Browse_Btn: "Browse",
  Acceptable_Documents: "Acceptable Documents",
  Type: "Type",
  UploadHint: "  Please upload your jpg,jpeg, png, or pdf file only",
  SELECTED_DOCUMENTS_ERROR: "You must select at least one document",
  Us_Passport: "U.S Passport",
  Unexpired_state_issued_DriverLicense:
    "Unexpired state-issued Driver's License",
  Learners_PermitorNon_Driver_Identification_Card:
    "Learner's Permit, or Non-Driver's Identification",
  Official_School_Record: "Official School Record",
  School_ID: "School ID",
  Permanent_Resident_Card: "Permanent Resident Card",

  No_FILE_SELECTED: "No file selected ",

  APPROVAL_STATUS: "Approval Pending",
  FILE_NAME: "File Name",
  DELETE_BTN: "Delete",
  PROOF_OF_AGE_DESCRIPTION:
    "To ensure accurate record-keeping and participant identification, we require a copy of your child's identification document, such as a passport, Unexpired state-issued Driver's License, Learner's Permit, Non-Driver's Identification, Official School Record, School ID or Permanent Resident Card. This verification process is crucial for program administration and ensuring the safety and security of all participants.",
  //Proof of SSN
  PROOF_OF_SSN: "Proof of SSN",
  BROWSE_BTN: "Browse",
  ACCEPTABLE_DOCUMENTS: "Acceptable Documents",
  TYPE: "Type",
  UPLOAD_HINT: "Only jpg, jpeg, png and pdf files are supported. ",
  SELECTED_DOCUMENTS_ERROR: "You must select at least one document",
  NO_FILE_SELECTED: "No File Selected ",
  LETTER_SSN:
    "Letter from the Social Security Administration (must show participant's name and SSN)",
  SHOWING_PARTICIPANT_SSSN: "2014 W-2 (showing participant's name and SSN)",
  SSN_CARD_DOC: "Social Security Card",
  LETTER_DOC: "Letter from the Social Security Administration ",
  W2_DOC: "2014 W-2",
  PROOF_OF_SSN_DESCRIPTION:
    "To ensure accurate record-keeping and participant identification, we require a copy of your child's identification document, such as a Letter from the Social Security Administration (must show participant's name and SSN) or 2014 W-2 form (showing participant's name and SSN). This verification process is crucial for program administration and ensuring the safety and security of all participants.",

  //Proof of work
  INDEX_NAME: "Job Application",
  PROOF_OF_WORK: "Proof of Work Authorization",
  BROWSE_BTN: "Browse",
  ACCEPTABLE_DOCUMENTS: "Acceptable Documents",
  TYPE: "Type",
  UPLOAD_HINT: "Only jpg, jpeg, png and pdf files are supported. ",
  SELECTED_DOCUMENTS_ERROR: "You must select at least one document",
  NO_FILE_SELECTED: "No File Selected ",
  PROOF_OF_WORK_DESCRIPTION:
    "To ensure accurate record-keeping and participant identification, we require a copy of your child's identification document, such as a Photo ID and U.S Birth Certificate or Social Security Card, U.S Passport, Permanent Resident Card or INS Form, Unexpired Foreign Passport with I-551 Stamp. This verification process is crucial for program administration and ensuring the safety and security of all participants.",

  ACCEPTABLE_DOCUMENTS_01:
    "A Photo ID and U.S Birth Certificate (Photo ID must be a state-issued driver's license, ID card, or School ID)",
  ACCEPTABLE_DOCUMENTS_02:
    "A Photo ID and a Social Security Card (Photo ID must be a state-issued driver's license, ID card, or School ID)",
  ACCEPTABLE_DOCUMENTS_03:
    "U.S Passport, Permanent Resident Card, or INS Form I-766 with Unexpired Employment Authorization",
  ACCEPTABLE_DOCUMENTS_04:
    "Unexpired Foreign Passport with I-551 Stamp or Attached INS Form I-94",

  DOC_TYPE_01: "A Photo ID and U.S Birth Certificate",
  DOC_TYPE_02: "A Photo ID and a Social Security Card",
  DOC_TYPE_03: "U.S Passport, Permanent Resident Card, or INS Form",
  DOC_TYPE_04: "Unexpired Foreign Passport or Attached INS Form",
  APPROVAL_PENDING: "Approval Pending",

  //transportation
  Index_Name: "Proof of Transportation",
  Submit_Btn: "Submit",
  Card_Number: "Card Number",
  Card_Fair: "Card Fair",
  Card_Issue_Date: "Card Issue Date",

  //error messages
  MUST_ENTER_CARD_NUMBER: "You must enter a Card Number",
  MUST_ENTER_CARD_FAIR: "You must enter a Card Fair",
  MUST_ENTER_CARD_ISSUEDATE: "You must enter a Card Issue Date",

  //certificate
  INDEX_NAME_CERTIFICATE: "Certification",
  //resume
  UPLOAD_HINT_ONE: "Only pdf files are supported. ",
  UPLOAD_BTN: "Upload",
  DOWNLOAD_BTN: "Download",

  //sideBar navigation
  RESUME_NAVI: "Resume",
  PROOF_OF_AGE_NAVI: "Proof of Age",
  PROOF_OF_SSN_NAVI: "Proof of SSN",
  PROOF_OF_WORK_NAVI: "Proof of Work",
  PROOF_OF_TRANSPORTATION_NAVI: "Proof of Transportation",
  PROOF_OF_RESIDENCE_NAVI: "Proof of Residency",
  CERTIFICATE_NAVI: "Certificate",
  ORIENTATION_NAVI: "Orientation",
  BANKING_NAVI: "Banking",

  //parent consent form
  GENERATE_QR: "Generate QR",
  SIGNATURE: "Your Signature",
  CERTIFY_BODY:
    "certify that I am the parent/ guardian of the minor applicant whose name appears above, and hereby give my consent for the minor to participate in youth employment programs administered by the D.C. Department of Employment Services (DOES) Office of Youth Programs (OYP) which include the Marion S. Barry Summer Youth Employment Program (SYEP); the Marion Barry Youth Leadership Institute ( MBYLI); the Year-Round In- School and Out-of-School Programs; the High School Internship Program (HSIP); and the College Internship Program (CIP); from the date on the bottom of this consent form until such time the minor is no longer eligible to participate in youth employment programs or I revoke this consent in writing. I further certify that all of the information contained within the minor’s application is correct and true and that by enrolling my child in any OYP programs I hereby give permission to DOES and its partner organizations to photograph/interview my child. It is my understanding that this photograph/interview or portions may be used by DOES and its partner organizations to describe, promote, and publicize its programs. I agree to participate in this project without financial remuneration, and I understand that this releases DOES and its partner organizations from any future claims, as well as from any liability, arising from the use of said photograph/interview. I understand that by signing this form and enrolling my child in programs offered by OYP in accordance with the District of Columbia Official Code Division V, Title 32, Chapter 2, I consent to the release of certain education records related to my child to DOES as of the date by my signature below for the purpose of verifying my child’s eligibility for these programs. I understand that the specific education records to be released to DOES include my child’s first name, last name, date of birth, address, enrollment status, grade level, and attendance data. I further understand that DOES will use this information for no other purpose than verifying that my child is eligible for its programs and will safeguard it against further disclosure. I further understand that I have a right to inspect, review and challenge any of my child’s education records and that I may request a copy of the records to be released to DOES pursuant to this consent by contacting the registrar or other responsible school official at my child’s school. Further, I understand that by enrolling my child in programs offered by DOES, I consent to my child participating in an on-going independent evaluation of the effectiveness of these programs. Further, I understand that DOES may contact my child’s school for up to two years after their participation to obtain certain education records showing their progress, including my child’s enrollment status, grades, test scores, suspensions, and attendance data and that DOES may survey or interview my child about its programs as part of this evaluation. I understand that any information collected will be used solely to assess DOES programs and to track general group trends. Individual responses will not be made public and neither my child’s name nor any identifiers will be used in any report. Further, I understand that participation in any DOES evaluation activity is completely voluntary and my child may withdraw at any time with no consequences and may opt-out of participating in the evaluation by emailing summerjobs@dc.gov or by contacting DOES via the contact information included on this form.",
  SUBMIT: "Submit",
  PARENT_EMAIL_LABEL: "Parent's Email",
};
export default locale;
